/*******************************************************************************
* Project: SMTM_EXM
* Summary:
*    Define PhoneNumberFormat
* History:
*    ThaiTV            2022/01/02    Create
******************************************************************************/

import { Pipe, PipeTransform } from '@angular/core';
import { Utility } from '../shared/utility/utility';
@Pipe({ name: 'phoneNumberFormat' })
export class PhoneNumberFormat implements PipeTransform {
    regHaftWidth = /^[0-9]*$/;
    constructor(
        public ulti: Utility,
    ) { }
    transform(pStrPhone: string): string {
        try {
            if (!this.ulti.isNullOrEmpty(pStrPhone)) {
                let strHaftWidth = '';
                for (let i = 0; i < pStrPhone.length; i++) {
                    const char = pStrPhone.charAt(i);
                    const reg = new RegExp(this.regHaftWidth);
                    if (reg.test(char)) {
                        strHaftWidth += char;
                    }
                }
                let strModel = null;
                if (this.ulti.isNullOrEmpty(strHaftWidth)) {
                    strModel = '';
                } else {
                    strModel = this.showForm(strHaftWidth);
                }
                return strModel;
            } else {
                return '';
            }
        } catch (err) {
            return '';
        }
    }
    showForm(value: string) {
        return this.ulti.setAreaNumber(value);
    }
}
